import React from "react"

import { useRoomFormContext } from "../contexts/RoomFormContext"
import { RoomFormHint } from "./RoomFormHint"
import { RoomFloorInput } from "./inputs/RoomFloorInput"
import { RoomLabelInput } from "./inputs/RoomLabelInput"
import { RoomNumberInput } from "./inputs/RoomNumberInput"
import { RoomPositionInput } from "./inputs/RoomPositionInput"
import { RoomProjectInput } from "./inputs/RoomProjectInput"

export const RoomFormGeneralTab = React.memo(() => {
  const { shouldShowHint, onHintClose, hideProject } = useRoomFormContext()

  return (
    <div className="room-form__general-tab room-form__tab-content">
      {!hideProject && <RoomProjectInput />}
      <RoomNumberInput />
      <RoomLabelInput />
      <RoomFloorInput />
      <RoomPositionInput />
      {shouldShowHint && onHintClose && <RoomFormHint onClose={onHintClose} />}
    </div>
  )
})
